// Baner nad każdym ekranem, gdy nowy egzemplarz czeka na zgodę (POROWNANIE.md 0.2, trzeci baner powłoki obok serwisu
// i zaproszeń - jak makieta): jeden - „Akceptuj” tą samą trasą co kafelek w Urządzeniach (zgoda na TEN egzemplarz),
// kilka - „Zobacz” (lista na ekranie Urządzenia). Dane z kolejki api/oczekujace.ts; na ekranie Urządzeń baner znika.
import { useLocation, useNavigate } from "react-router";
import { t } from "../../i18n/t";
import { akceptuj, useOczekujace } from "../../api/oczekujace";
import { opisBledu } from "../../api/zaplecze";
import { IkonaUrzadzenia } from "../../uklad/ikony";
import type { BanerDane } from "../../uklad/Powloka";
import { pokazTost } from "../../uklad/tost";

export function useBaneryOczekujacych(): BanerDane[] {
  const czeka = useOczekujace().filter((p) => !p.zaakceptowane);
  const { pathname } = useLocation();
  const idz = useNavigate();
  if (czeka.length === 0 || pathname === "/urzadzenia") return [];
  const jeden = czeka.length === 1 ? czeka[0] : undefined;
  return [{ id: "oczekujace", rodzaj: "nowe", ikona: IkonaUrzadzenia,
    tresc: jeden ? t("Nowe urządzenie czeka na akceptację: {nazwa}.", { nazwa: jeden.nazwa || jeden.sn })
      : t("Nowe urządzenia czekają na akceptację ({n}).", { n: czeka.length }),
    etykietaAkcji: jeden ? t("Akceptuj") : t("Zobacz"),
    onAkcja: () => (jeden
      ? void akceptuj(jeden.sn, jeden.ident_hash).then(() => pokazTost(t("Urządzenie zaakceptowane.")), (b: unknown) => pokazTost(opisBledu(b)))
      : void idz("/urzadzenia")) }];
}
